module.exports = function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isFunction.js
// module id = ./node_modules/ramda/src/internal/_isFunction.js
// module chunks = 54 55 56